import styled from "styled-components"

export const Wrapper = styled.div`
.form-group label {
    color: var(--font-color-blue002e5c);
    font-family: var(--general-small-label-font-family);
    font-size: var(--general-small-label-font-size);
    font-style: normal;
    font-weight: var(--general-small-label-font-weight);
    line-height: normal;
}

.form-control {
  border-radius: 6px;
  background: #f4f6f9;
  max-width: 469.002px;
  width: 100%;
  height: 48px;
  @media only screen and (min-width: 280px) and (max-width: 767px) {
    width: 100%
  }
}
.image-upload {
  overflow: hidden;
}
.badge-danger {
  margin-left: 10px;
  color: var(--font-color-blue002e5c);
  background-color: transparent;
  padding-left: 0;
}
.image-upload-control {
  margin-top: 10px;
  overflow: hidden;
  display: none;
}
.btn-file-upload-clear{
    background-color: #F4F6F9;
}


.btn-toolbar-disable{
  float: right;
  height: 48px;
  width:150px;
  border-radius: 6px;
  border: 0;
  background: #F0F0F3;  
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--font-color-grayb5b5c3);
  input{
    color: var(--font-color-white);
    font-size: var(--general-large-body-font-size);
    font-weight: var(--general-large-body-font-weight);
    line-height: 150%; 
  }

}
.btn-toolbar-disable:hover{
  color: var(--font-color-grayb5b5c3);
   background: #F0F0F3;  
}


.custom-radio{
  padding-left: 0;
}
`
